import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function BarChartComponent({ options, onBarClick, selectedItems = [] }) {
  const handleClick = (event) => {
    const chart = ChartJS.getChart(event.target);
    const points = chart.getElementsAtEventForMode(event, 'nearest', { intersect: true }, false);

    if (points.length) {
      const firstPoint = points[0];
      const label = chart.data.labels[firstPoint.index];
      onBarClick(label);
    }
  };

  const labelsWithFallback = options.data.labels.map((label) => {
    if (!label) return '...';
    return label.length > 25 ? label.slice(0, 23) + '...' : label;
  });

  const highlightedData = {
    ...options.data,
    labels: labelsWithFallback,
    datasets: options.data.datasets.map((dataset) => ({
      ...dataset,
      backgroundColor: dataset.data.map((_, idx) => {
        const originalLabel = options.data.labels[idx]; // importante: usar o label original aqui
        return selectedItems?.includes(originalLabel) ? "#0D63A9" : "#0A91FF";
      }),
    })),
  };

  const totalBars = options.data.labels.length;
  const barWidth = 25;
  const chartWidth = Math.max(totalBars * barWidth, 600);

  return (
      <div style={{ width: '100%', overflowX: 'auto', height: '100%'}}>
        <div style={{ width: chartWidth, height: '100%' }} onClick={handleClick}>
          <Bar data={highlightedData} options={options.options} />
        </div>
      </div>
  );
}

export default BarChartComponent;
